
  import { WordInterface } from "@/models/words"
  import generateID from "@/utils/generateID"
  import { computed, defineComponent, ref } from "vue"
  import { useStore } from "vuex"
  import "./scss/translations/Translation.scss"

  export default defineComponent({
    name: "TranslateWord",
    props: {
      index: Number,
      isPagesNull: Boolean
    },
    inject: ["Ti18N"],
    setup(props: any) {
      const store = useStore()
      const wordTranslation = ref("")
      const radioLang = ref<any>("ru")
      const currentDictionary = computed(() => store.getters.currentDictionary)
      const userID = computed(() => store.getters.profile.id)
      const result = computed<{ ruWord: string, enWord: string }>(() => store.getters.translatedDictResults)
      const btn = ref<any>(null)

      const findTanslate = async () => {
        await store.dispatch("setOwnTranslate", { toLang: radioLang.value == "en" ? "ru" : "en", word: wordTranslation.value, fromLang: radioLang.value })
        wordTranslation.value = ""
      }

      const addToDictionary = async () => {
        btn.value.disabled = true
        await store.dispatch("sendEditWords", {
          title: currentDictionary.value.title,
          id: currentDictionary.value.id,
          editWords: [...currentDictionary.value.words, { english: result.value.enWord, russian: result.value.ruWord, id: generateID(currentDictionary.value.words.map((item: WordInterface) => item.id)) }],
          userid: userID.value,
          wordsid: props.index,
        })
        store.commit("SET_TRANSLATED_DICT_WORDS", { enWord: "", ruWord: "" })
        btn.value.disabled = false
      }

      return { findTanslate, wordTranslation, radioLang, result, addToDictionary, btn }
    },
  })
